import { createFileRoute, Link } from "@tanstack/react-router"
import { Sparkles, Users } from "lucide-react"

export const Route = createFileRoute("/recruit/talent")({
  component: TalentPage,
})

function TalentPage() {
  return (
    <div className="space-y-6">
      <div className="mkt-talent-head">
        <div>
          <h1 className="mkt-page-title">Find Talent</h1>
          <p className="mkt-page-sub">
            Search the community candidate pool by role, skills, and location.
          </p>
        </div>
      </div>

      <div className="mkt-panel flex flex-col items-center gap-4 py-16 text-center">
        <span className="inline-flex items-center gap-1.5 rounded-full bg-[color:var(--wf-lime-wash)] px-3 py-1 text-xs font-semibold uppercase tracking-wide text-[color:var(--wf-lime-text)]">
          <Sparkles className="size-3.5" aria-hidden />
          Coming soon
        </span>
        <div
          className="flex size-14 items-center justify-center rounded-2xl bg-[color:var(--wf-wash)] text-[color:var(--wf-ink)]"
          aria-hidden
        >
          <Users className="size-7" />
        </div>
        <h2 className="text-xl font-semibold text-[color:var(--wf-ink)]">
          Talent search is on the way
        </h2>
        <p className="max-w-md text-sm text-[color:var(--wf-mute)]">
          We&rsquo;re rebuilding candidate sourcing with smarter matching. In the
          meantime, post a job and review applicants from the Jobs tab &mdash;
          strong matches surface automatically.
        </p>
        <Link to="/recruit/jobs" className="home-wf-btn home-wf-btn--lime mt-1">
          Go to Jobs
        </Link>
      </div>
    </div>
  )
}
